<template>
  <div class="instructions">
    <div v-html="instructions"></div>
    <div class="btn-v">
      <button>
        <a :href="fileUrl" target="_blank">下载期刊投稿模板</a>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "Instructions",
  data() {
    return {
      instructions: "",
      fileUrl: "",
    };
  },
  created() {
    this.getInstructions();
  },
  methods: {
    getInstructions() {
      this.$request.getInstructions().then((res) => {
        if (res.code === 200) {
          this.instructions = res.data.instructions;
          try {
            const fileArr = JSON.parse(res.data.masterplate);
            this.fileUrl = fileArr[0].url;
          } catch (e) {
            this.fileUrl = "";
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.instructions {
  padding: 0 55px;
  margin-top: 30px;

  ::v-deep {
    p {
      line-height: 30px;
      text-align: justify;
    }
  }

  .btn-v {
    padding-top: 20px;
    border-top: 1px solid #e1e1e1;
    margin-top: 30px;

    button {
      width: 188px;
      height: 40px;
      background: #406cdd;
      border: 1px solid #ffffff;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      line-height: 40px;
      cursor: pointer;

      &:active {
        opacity: 0.7;
      }
    }
  }
}
</style>
